/**
 * URL para GET /public/files/... na API.
 * Remove query/hash do segmento (dados legados) e junta token sem duplicar "?".
 */

/** Só normaliza o segmento; o /scorm/player expande pasta→href via imsmanifest (Rise, iSpring, …). */
export const normalizeScormLaunchSegment = (segment) => {
    let raw = String(segment ?? '').trim();
    raw = raw.split('?')[0].split('#')[0].replace(/^\/+/, '').replace(/\/$/, '');
    return raw;
};

/** Caminho típico iSpring (…/res/index.html), Rise (scormdriver/indexAPI.html), ou manifest no path. */
export const isScormStyleLaunchPath = (segment) => {
    const s = String(segment ?? '').toLowerCase();
    if (!s) return false;
    if (s.includes('imsmanifest.xml')) return true;
    if (s.includes('/res/index.html') || s.includes('\\res\\index.html')) return true;
    if (s.includes('scormdriver')) return true;
    if (s.includes('indexapi.html')) return true;
    const pathOnly = s.split('?')[0].split('#')[0];
    if (/\/res\/?$/.test(pathOnly)) return true;
    return false;
};

/** html_externo aponta para pacote na nossa API (/public/files/…), não para site terceiro. */
export const isUrlOurPublicFilesPackage = (url, apiBase, filesBase) => {
    const u = String(url ?? '').trim();
    if (!u) return false;
    const low = u.toLowerCase();
    if (low.includes('/public/files/')) return true;
    const fb = (filesBase || '').replace(/\/$/, '').toLowerCase();
    if (fb && low.startsWith(fb)) return true;
    try {
        const abs = new URL(u);
        const api = new URL((apiBase || '').replace(/\/$/, '') + '/');
        if (abs.hostname === api.hostname && low.includes('/public/files/')) return true;
    } catch (e) {
        /* ignore */
    }
    return false;
};

/** Player LMS na API (mesma origem que ficheiros SCORM). edition: '1.2' | '2004' */
export const buildScormPlayerUrl = (apiBase, idAula, launchSegment, authToken, edition = '1.2') => {
    const base = (apiBase || '').replace(/\/$/, '');
    const raw = String(launchSegment ?? '').trim();
    const launch = raw.split('?')[0].split('#')[0].replace(/^\/+/, '');
    let t = authToken;
    if (t != null && typeof t === 'object') {
        t = t.token ?? t.access_token ?? '';
    }
    const ed = edition === '2004' ? '2004' : '1.2';
    const q = new URLSearchParams();
    q.set('token', String(t));
    q.set('idAula', String(idAula));
    q.set('launch', launch);
    q.set('edition', ed);
    return `${base}/scorm/player?${q.toString()}`;
};

export const buildPublicFilesUrl = (filesBase, pathSegment, authToken) => {
    const base = (filesBase || '').replace(/\/$/, '');
    const raw = String(pathSegment ?? '').trim();
    const pathOnly = raw.split('?')[0].split('#')[0].replace(/^\/+/, '');
    let url = `${base}/${pathOnly}`;
    let t = authToken;
    if (t != null && typeof t === 'object') {
        t = t.token ?? t.access_token ?? '';
    }
    if (t) {
        const sep = url.includes('?') ? '&' : '?';
        url = `${url}${sep}token=${encodeURIComponent(String(t))}`;
    }
    return url;
};
